import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import services from '../services';
import $ from 'jquery';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { EODDetailsObject } from '../EODDetailsReportSchema';
import { validateProperty, validate } from "../../../Common";
import divisionService from '../../../Devision/services';
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import MessageModal from '../../../../UI/Modal/MessageModal';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import {
    Box,
    Button,
    makeStyles,
    TextField,
    MenuItem,
    InputLabel,
} from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    row: {
        marginTop: '1rem'
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecordAndNew: {
        backgroundColor: "#FFBE00"
    },
    colorRecord: {
        backgroundColor: "green",
    }

}));

const screenCode = 'EODDETAILSREPORT';

export function EODDetailsReportListing(props) {
    const componentRef = useRef();
    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisions, setDivisions] = useState();
    const [fields, setFields] = useState();
    const [errors, setErrors] = useState({});
    const [sessions, setSessions] = useState({});
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const getTodayDate = () => moment().format('YYYY-MM-DD');
    const classes = useStyles();
    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1070, 700]
    };
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "",
        disciption: "",
    });

    const schema = Joi.object(EODDetailsObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);

    const [collectionCategoryReport, setcollectionCategoryReport] = useState([])
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            status: "0",
            sessionID: "0",
            searchDate: moment().format('YYYY-MM-DD')
        }
    );
    const [reportData, setReportData] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        status: "",
        date: ""
    })
    const [totalValues, setTotalValues] = useState({
        totaleodfailcount: 0,
        totalnoOfSessions: 0,
        totalnoOfRSM: 0,
        totalnoOfGeneral: 0,
        totalnoOfCash: 0,
        totalnoOfNonPluckers: 0,
        totalnoOfTaskCount: 0,
    });

    const [csvHeaders, setCsvHeaders] = useState([]);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            setGroupDropDownData()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown(),
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(
            GetDivisionForDropDown(),
            getMobileSessions()
        )
    }, [searchForm.estateID]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
            getMobileSessions()
        )
    }, [searchForm.divisionID]);

    useEffect(() => {
        destroyDataTable();
        setIsTableHide(false);
        createDataTable();
    }, [collectionCategoryReport]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
            getMobileSessions()
        )
    }, [searchForm.searchDate]);

    useEffect(() => {
        trackPromise(
            getMobileSessions()
        )
    }, [searchForm.fieldID]);


    useEffect(() => {
        destroyDataTable();
        setIsTableHide(false);
        createDataTable();
    }, [reportData]);

    useEffect(() => {
        if (reportData.length != 0) {
            calculateTotalQty()
        }
    }, [reportData]);

    useEffect(() => {
    setSearchForm(prev => ({
        ...prev,
        searchDate: getTodayDate()
    }));
}, []);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    async function getMobileSessions() {
        if (searchForm.searchDate !== "")
            getMobileSessionsForDropDown();
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEODDETAILSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setSearchForm({
                ...searchForm,
                groupID: token.groupID
            });

        } else {
            setSearchForm({
                ...searchForm,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await groupService.getGroupsForDropdown();
        setGroups(result);
    }

    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(searchForm.groupID);
        setEstates(factoryList);
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(searchForm.estateID);
        setDivisions(routeList);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetAvialableFieldsForDropdown(searchForm);
        setFields(fields);
    }

    async function getMobileSessionsForDropDown() {
        const selectedSessions = await services.GetMobileSessionsForWeighReport(searchForm);
        setSessions(selectedSessions);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handlePChange(e) {
        e.preventDefault();
        resetReportState();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, EODDetailsObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setSearchForm({
            ...searchForm,
            [target.name]: value
        });

        setErrors(error);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        resetReportState();
        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0",
            sessionID: "0",
            status: "0",
            searchDate: getTodayDate()
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        resetReportState();
        setSearchForm({
            ...searchForm,
            divisionID: target.value,
            fieldID: "0",
            sessionID: "0",
            status: "0",
            searchDate: getTodayDate()
        });
    }

    function handleDateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            fieldID: "0",
            sessionID: "0",
            searchDate: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, EODDetailsObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }
    async function handleSearch(e) {
        e.preventDefault();

        destroyDataTable();
        setIsTableHide(true);

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchForm);
        var result = await services.GetEODDetailsReportData(searchForm);
        setReportData(result);

        if (result.length > 0) {
            result.forEach(x => {
                x.date = x.date.split('T')[0];
            })
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
            setMessageModel({
                ...messageModel,
                hidden: false,
                type: "Error",
                disciption: "No Records To Display",
            });
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setcollectionCategoryReport(reportData);
    }

    function calculateTotalQty() {
        const totaleodfailcount = reportData.reduce((accumulator, current) => accumulator + current.eodFailCount, 0);
        const totalnoOfSessions = reportData.reduce((accumulator, current) => accumulator + current.noOfSessions, 0);
        const totalnoOfRSM = reportData.reduce((accumulator, current) => accumulator + current.noOfRSMEmpCount, 0);
        const totalnoOfGeneral = reportData.reduce((accumulator, current) => accumulator + current.noOPluckingEmpCount, 0);
        const totalnoOfCash = reportData.reduce((accumulator, current) => accumulator + current.noOfCashEmpCount, 0);
        const totalnoOfNonPluckers = reportData.reduce((accumulator, current) => accumulator + current.noOfSundryEmpCount, 0);
        const totalnoOfTaskCount = reportData.reduce((accumulator, current) => accumulator + current.taskCount, 0);

        setTotalValues({
            ...totalValues,
            totaleodfailcount: totaleodfailcount,
            totalnoOfSessions: totalnoOfSessions,
            totalnoOfRSM: totalnoOfRSM,
            totalnoOfGeneral: totalnoOfGeneral,
            totalnoOfCash: totalnoOfCash,
            totalnoOfNonPluckers: totalnoOfNonPluckers,
            totalnoOfTaskCount: totalnoOfTaskCount,
        })
    };

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Field Officer': x.fieldOfficer,
                    'Device Lang': x.deviceLang,
                    'Device Model': x.deviceModel,
                    'OS Version': x.osVersion == 0 ? '-' : x.osVersion,
                    'SOS Time': moment(x.eosTime).format('YYYY-MM-DD, hh:mm:ss a'),
                    'EOD Time': x.eodTime === null ? '-' : moment(x.eodTime).format('YYYY-MM-DD, hh:mm:ss a'),
                    'EOD Fail Count': x.eodFailCount == 0 ? '-' : x.eodFailCount,
                    'No. of Sessions': x.noOfSessions,
                    'No. of RSM Pluckers': x.noOfRSMEmpCount,
                    'No. of General Pluckers': x.noOPluckingEmpCount,
                    'No. of Cash Pluckers': x.noOfCashEmpCount,
                    'No. of Non Pluckers': x.noOfSundryEmpCount,
                    'No. of Task Count': x.taskCount,
                    'Version': x.version,
                    'Installation Date': x.installationDate == null ? '-' : moment(x.installationDate).format('YYYY-MM-DD'),
                };
                res.push(vr);
            });
            var vr = {
                'Field Officer': 'Total',
                'EOD Fail Count': totalValues.totaleodfailcount,
                'No. of Sessions': totalValues.totalnoOfSessions,
                'No. of RSM Pluckers': totalValues.totalnoOfRSM,
                'No. of General Pluckers': totalValues.totalnoOfGeneral,
                'No. of Cash Pluckers': totalValues.totalnoOfCash,
                'No. of Non Pluckers': totalValues.totalnoOfNonPluckers,
                'No. of Task Count': totalValues.totalnoOfTaskCount,
            };

            res.push(vr);
            res.push([]);
            var vr = {
                'Field Officer': 'Group : ' + selectedSearchValues.group,
                'Device Lang': 'Operation Entity : ' + selectedSearchValues.estate,
                'Device Model': 'Collection Point : ' + selectedSearchValues.division,
                'OS Version': 'Status : ' + (selectedSearchValues.status === "0" ? "All" : selectedSearchValues.status === "1" ? "Pending" : selectedSearchValues.status === "2" ? "Approved" : "Rejected"),
                'SOS Time': 'Date : ' + selectedSearchValues.date
            };
            res.push(vr);
        }
        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(reportData);

        var settings = {
            sheetName: 'EOD Details Report',
            fileName:
                'EOD Details Report - ' +
                selectedSearchValues.date,
            writeOptions: {}
        };

        let keys = Object.keys(file[0]);
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem });
        });

        xlsx(csvHeaders, file, settings, true)
    }


    function destroyDataTable() {
        for (const [key, value] of Object.entries(sessions)) {
            $(`#${key}`).DataTable().destroy();
        }
    }

    function createDataTable() {
        for (const [key, value] of Object.entries(sessions)) {

            var t = $(`#${key}`).DataTable({
                retrieve: true,
                destroy: true,
                scrollX: true,
                "columnDefs": [{
                    "searchable": false,
                    "orderable": false,
                    "targets": 0
                }],
                "order": [[1, 'asc']]
            });

            t.on('order.dt search.dt', function () {
                t.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1;
                });
            }).draw();
        }
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            feild: fields[searchForm.fieldID],
            status: searchForm.status,
            date: searchForm.searchDate
        })

    }

    function resetReportState() {
    destroyDataTable();
    setReportData([]);
    setcollectionCategoryReport([]);
    setIsReportButtonsEnabled(false);
    setIsTableHide(true);

    setTotalValues({
        totaleodfailcount: 0,
        totalnoOfSessions: 0,
        totalnoOfRSM: 0,
        totalnoOfGeneral: 0,
        totalnoOfCash: 0,
        totalnoOfNonPluckers: 0,
        totalnoOfTaskCount: 0,
    });
}



    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div ref={pdfRef} className="card">
                        <PageHeader
                            title="EOD Details Report"
                        />
                        <div className="card-body">

                            <div className="row">
                                <div className="col">
                                    <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                        <div className="form-group row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="groupID">Group *</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="groupID"
                                                    disabled={!permissionList.isGroupFilterEnabled}
                                                    name="groupID"
                                                    value={searchForm.groupID}
                                                    onChange={(e) => handleGroupChange(e.target)}>
                                                    <MenuItem value="0">--Select Group--</MenuItem>
                                                    {generateDropDownMenu(groups)}
                                                </Select>
                                                {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                                <Select fullWidth
                                                    id="estateID"
                                                    name="estateID"
                                                    disabled={!permissionList.isOperationEntityFilterEnabled}
                                                    value={searchForm.estateID}
                                                    onChange={(e) => handleEstateChange(e.target)}>
                                                    <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                                    {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                                </Select>
                                                {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="divisionID">Collection point *</InputLabel>
                                                <Select fullWidth
                                                    id="divisionID"
                                                    name="divisionID"
                                                    value={searchForm.divisionID}
                                                    onChange={(e) => handleDivisionChange(e.target)}>
                                                    <MenuItem value="0">--Select Collection point--</MenuItem>
                                                    {generateDropDownMenu(divisions)}
                                                </Select>
                                                {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="searchDate">Date *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="searchDate"
                                                    name="searchDate"
                                                    type="date"
                                                    value={searchForm.searchDate}
                                                    onChange={(e) => handleDateChange(e.target)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="status">Status</InputLabel>
                                                <Select
                                                    id="status"
                                                    select
                                                    fullWidth
                                                    name="status"
                                                    onChange={(e) => handlePChange(e)}
                                                    value={searchForm.status}>
                                                    <MenuItem value="0">--Select Status--</MenuItem>
                                                    <MenuItem value="1">Pending</MenuItem>
                                                    <MenuItem value="2">Approved</MenuItem>
                                                    {/*<MenuItem value="3">Rejected</MenuItem>*/}
                                                </Select>
                                            </div>

                                            <div className="col-md pb-1"></div>
                                        </div>

                                        <input
                                            type="submit"
                                            disabled={validate(schema, searchForm)}
                                            className="btn btn-primary"
                                            value="Generate"
                                        />
                                    </form>
                                </div>
                                <div class="w-100"></div>
                                <div className="col pl-5"
                                    style={{ maxWidth: "1460" }}
                                >

                                    <Box minWidth={1050}>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        {reportData.length > 0 ?
                                            <TableContainer component={Paper}>
                                                <Table className={classes.table} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow style={{ borderBottom: "2px solid black", border: "2px solid black" }}>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Field Officer</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Device Lang</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Device Model</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>OS Version</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>SOS Time</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>EOD Time</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>EOD Fail Count</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>No. of Sessions</TableCell>
                                                            <TableCell align="center" colSpan={3} style={{ fontWeight: "bold", border: "2px solid black" }}>Pluckers</TableCell>
                                                            <TableCell align="center" colSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Non Pluckers</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Version</TableCell>
                                                            <TableCell align="center" rowSpan={2} style={{ fontWeight: "bold", border: "2px solid black" }}>Installation Date</TableCell>
                                                        </TableRow>
                                                        <TableRow style={{ borderBottom: "2px solid black", border: "2px solid black" }}>
                                                            <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>RSM</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>General</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Cash</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>No. of Employee Count</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>No. of Task Count</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                            <TableRow key={i} style={{ borderBottom: "2px solid black", border: "2px solid black" }}>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.fieldOfficer}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.deviceLang}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.deviceModel}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.osVersion == 0 ? '-' : row.osVersion}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {moment(row.eosTime).format('YYYY-MM-DD, hh:mm:ss a')}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.eodTime === null ? '-' : moment(row.eodTime).format('YYYY-MM-DD, hh:mm:ss a')}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.eodFailCount == 0 ? '-' : row.eodFailCount}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.noOfSessions}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.noOfRSMEmpCount}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.noOPluckingEmpCount}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.noOfCashEmpCount}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.noOfSundryEmpCount}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.taskCount}</TableCell>
                                                                <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}> {row.version}</TableCell>
                                                                <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black" }}> {row.installationDate == null ? '-' : moment(row.installationDate).format('YYYY-MM-DD')}</TableCell>
                                                            </TableRow>
                                                        )
                                                        )}
                                                    </TableBody>
                                                    <TableRow style={{ borderBottom: "2px solid black", border: "2px solid black" }}>
                                                        <TableCell align={'center'} style={{ borderBottom: "none", border: "2px solid black" }}><b>Total</b></TableCell>
                                                        <TableCell style={{ borderBottom: "none", border: "2px solid black" }}></TableCell>
                                                        <TableCell style={{ borderBottom: "none", border: "2px solid black" }}></TableCell>
                                                        <TableCell style={{ borderBottom: "none", border: "2px solid black" }}></TableCell>
                                                        <TableCell style={{ borderBottom: "none", border: "2px solid black" }}></TableCell>
                                                        <TableCell style={{ borderBottom: "none", border: "2px solid black" }}></TableCell>
                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", border: "2px solid black" }}>
                                                            <b> {totalValues.totaleodfailcount} </b>
                                                        </TableCell>
                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", border: "2px solid black" }}>
                                                            <b> {totalValues.totalnoOfSessions} </b>
                                                        </TableCell>
                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", border: "2px solid black" }}>
                                                            <b> {totalValues.totalnoOfRSM} </b>
                                                        </TableCell>
                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", border: "2px solid black" }}>
                                                            <b> {totalValues.totalnoOfGeneral} </b>
                                                        </TableCell>
                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", border: "2px solid black" }}>
                                                            <b> {totalValues.totalnoOfCash} </b>
                                                        </TableCell>
                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", border: "2px solid black" }}>
                                                            <b> {totalValues.totalnoOfNonPluckers} </b>
                                                        </TableCell>
                                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", border: "2px solid black" }}>
                                                            <b> {totalValues.totalnoOfTaskCount} </b>
                                                        </TableCell>
                                                        <TableCell style={{ borderBottom: "none", border: "2px solid black" }}></TableCell>
                                                        <TableCell style={{ borderBottom: "none", border: "2px solid black" }}></TableCell>
                                                    </TableRow>
                                                </Table>
                                                <TablePagination
                                                    component="div"
                                                    count={reportData.length}
                                                    onChangePage={handlePageChange}
                                                    onChangeRowsPerPage={handleLimitChange}
                                                    page={page}
                                                    rowsPerPage={limit}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                />
                                            </TableContainer>
                                            : null}
                                    </Box>
                                    {reportData.length > 0 ?
                                        <Box display="flex" justifyContent="flex-end" p={2}>
                                            <Button
                                                color="primary"
                                                id="btnRecord"
                                                type="submit"
                                                variant="contained"
                                                style={{ marginRight: '1rem' }}
                                                className={classes.colorRecord}
                                                onClick={createFile}
                                                size="small"
                                            >
                                                EXCEL
                                            </Button>
                                            <div>&nbsp;</div>
                                            <style>
                                                {`
                                                    @page {
                                                        size: A4 landscape; /* Set the size and orientation here */
                                                        margin: 20mm; /* Adjust the margin as needed */
                                                    }
                                                    `}
                                            </style>
                                            <ReactToPrint
                                                documentTitle={"EOD Details Report"}
                                                trigger={() => <Button
                                                    color="primary"
                                                    id="btnCancel"
                                                    variant="contained"
                                                    style={{ marginRight: '1rem' }}
                                                    className={classes.colorCancel}
                                                >
                                                    PDF
                                                </Button>}
                                                content={() => componentRef.current}
                                            />
                                            <div hidden={true}>
                                                <CreatePDF ref={componentRef}
                                                    searchData={selectedSearchValues} reportData={reportData}
                                                    totalValues={totalValues} />
                                            </div>
                                        </Box> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    )
}

